export default "__VITE_ASSET__JQh51XT2__"